import { Mesh, Object3D } from 'three'
import { LHFEventDispatcher } from '../../com/LHFEventDispatcher'
import * as _ from 'underscore'
import { PANO_CONFIG } from './PanoConfig'
import { createPanoContentGeo, createAniMeshBasicMaterial } from './utils'
/**
 * 全景动画
 */
class PanoAni extends LHFEventDispatcher {
  constructor(scene_) {
    super()
    this.scene = scene_
    this.aniHolder = new Object3D()
    this.scene.add(this.aniHolder)
    this.anis = []
  }
  /**
   * 设置当前全景
   */
  setCurPano(scene_) {
    this.sceneData = scene_

    // 清除历史动画
    this.clearAni()

    // 展示需要显示的动画
    let defaultShowAnis = _.filter(
      this.sceneData.anis,
      item => item.defaultShow
    )
    // 展示动画
    defaultShowAnis.forEach(element => {
      this.showAni(element)
    })
  }
  /**
   * 清除动画
   */
  clearAni() {
    while (this.aniHolder.children.length) {
      var ani = this.aniHolder.remove(this.aniHolder.children[0])
      // 如果是模型
      if (ani.type === 'Mesh') {
        let geo = ani.geometry
        let mtl = ani.material
        if (geo) {
          geo.dispose()
        }
        if (mtl) {
          mtl.map.dispose()
          mtl.dispose()
        }
      }
    }
  }
  /**
   * 添加一个全景场景动画
   * @param {object} aniArr_
   */
  showAni(ani) {
    let sData = this.sceneData
    let geo = createPanoContentGeo(
      ani.left,
      ani.top,
      sData.width,
      sData.height,
      ani.width,
      ani.height,
      ani.scale,
      ani.radiusRatio
    )
    let aniMtl = createAniMeshBasicMaterial(ani)
    let aniMesh = new Mesh(geo, aniMtl)
    aniMesh.scale.copy(PANO_CONFIG.PAN_MESH_SCALE)
    this.aniHolder.add(aniMesh)
  }
}

export { PanoAni }



// WEBPACK FOOTER //
// ./src/webgl/panorama/PanoAni.js